var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-text-area',{attrs:{"id":"textarea","placeholder":"Enter something...","rows":"3","max-rows":"6"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }